import { Link } from "react-router-dom";
import { Clock, ArrowRight } from "lucide-react";
import { optImg } from "../lib/image";

const TourCard = ({ tour }) => (
  <Link
    to={`/tours/${tour.slug}`}
    data-testid={`tour-card-${tour.slug}`}
    className="group flex flex-col overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-soft transition-all duration-300 hover:-translate-y-1 hover:shadow-lift"
  >
    <div className="relative aspect-[4/3] overflow-hidden">
      <img
        src={optImg(tour.image_url, 800)}
        alt={`${tour.name} — private tour in Corfu with Aloha Corfu Tours`}
        loading="lazy"
        decoding="async"
        className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
      />
      <span className="absolute left-3 top-3 rounded-full bg-white/90 px-3 py-1 text-xs font-semibold text-pine backdrop-blur">
        {tour.category}
      </span>
    </div>
    <div className="flex flex-1 flex-col p-5">
      <h3 className="font-display text-xl font-semibold text-pine leading-snug">{tour.name}</h3>
      <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-gray-500">{tour.short_description}</p>
      <div className="mt-4 flex items-center justify-between">
        {tour.duration ? (
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-gray-500">
            <Clock className="h-3.5 w-3.5 text-seafoam-dark" /> {tour.duration}
          </span>
        ) : <span />}
        <span className="inline-flex items-center gap-1 text-sm font-semibold text-pine transition-transform duration-300 group-hover:translate-x-1">
          View details <ArrowRight className="h-4 w-4" />
        </span>
      </div>
    </div>
  </Link>
);

export default TourCard;
